import React from 'react';

const Homepage = () => {
  return (
    <div id='newsletter-form' className='container py-4' style={{ position: 'relative' }}>
      <h2 className='mb-3 mb-xxl-4 px-2'>Newsletter abonnieren</h2>
      <form action='submit' className='px-2' style={{ zIndex: 100 }}>
        <span>Anrede</span>
        <div className='d-flex mb-4 mt-1' style={{ gap: '1.5rem' }}>
          <div className='form-check'>
            <input className='form-check-input' type='radio' name='flexRadioDefault' id='radio1' />
            <label className='form-check-label-radio ms-2' htmlFor='radio1'>
              {' '}
              Herr{' '}
            </label>
          </div>
          <div className='form-check'>
            <input className='form-check-input' type='radio' name='flexRadioDefault' id='radio2' />
            <label className='form-check-label-radio ms-2' htmlFor='radio2'>
              {' '}
              Frau
            </label>
          </div>
        </div>
        <div className='row gy-3'>
          <div className='col-12 col-lg-6'>
            <div className='mb-3 d-flex flex-column'>
              <label htmlFor='firstName' className='form-label'>
                Vorname
              </label>
              <input type='text' className='form-control form-control-lg' id='firstName' />
            </div>
          </div>
          <div className='col-12 col-lg-6'>
            <div className='mb-3 d-flex flex-column'>
              <label htmlFor='lastName' className='form-label'>
                Nachname
              </label>
              <input type='text' className='form-control' id='lastName' />
            </div>
          </div>
          <div className='col-12'>
            <div className='mb-3 d-flex flex-column'>
              <label htmlFor='email' className='form-label'>
                E-Mail*
              </label>
              <input type='email' className='form-control' id='email' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='form-check d-flex mb-2'>
            <div>
              <input
                className='form-check-input me-2'
                type='checkbox'
                defaultValue=''
                id='check1'
              />
            </div>
            <div>
              <label className='form-check-label' htmlFor='check1'>
                Ich habe die <u>Datenschutzerklärung</u> sowie das <u>Transparenzgebot</u> für die
                Speicherung meiner Daten aus diesem Kontaktformular gelesen und anerkannt.*
              </label>
            </div>
          </div>
          <div className='form-check d-flex'>
            <div>
              <input
                className='form-check-input me-2'
                type='checkbox'
                defaultValue=''
                id='chcek2'
              />
            </div>
            <div>
              <label className='form-check-label' htmlFor='check2'>
                Ja, ich möchte den <b>Newsletter von Standard Systeme abonnieren</b> und regelmäßig
                über neue Produkte und Angebotsaktionen informiert werden. Ich stimme zu, dass meine
                personenbezogenen Daten - wie in der <u>Datenschutzerklärung</u> beschrieben - zur
                Zusendung und Analyse verarbeitet werden. Ich weiß, dass ich diese Zustimmung
                jederzeit mit Wirkung für die Zukunft widerrufen kann.
              </label>
            </div>
          </div>
        </div>
        <div className='row justify-content-center my-4'>
          <button className='btn-form' type='submit'>
            Anfrage absenden
          </button>
        </div>
        <p>*Pflichtfelder</p>
      </form>
      <div className='close-btn'>
        <button />
      </div>
      <div className='wave' />
    </div>
  );
};

export default Homepage;
